import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const DraculasCastle = {
  id: "130",
  name: "Draculas Castle",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Draculas_Castle",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Dracula%27s_Castle',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        1.17, 1.17, 1.17, 1.67, 1.67, 1.67, 2.17, 2.17, 2.17, 2.67,
        2.67, 2.67, 2.67, 3.34, 3.34, 3.34, 3.84, 3.84, 3.84, 4.34,
        4.34, 4.34, 4.34, 5.00, 5.00, 5.00, 5.50, 5.50, 5.50, 6.00,
        6.00, 6.00, 6.00, 6.67, 6.67, 6.67, 7.17, 7.17, 7.17, 7.67,
        7.67, 7.67, 7.67, 8.34, 8.34, 8.34, 8.84, 8.84, 8.84, 9.34,
        9.34, 9.34, 9.34, 10.00, 10.00, 10.00, 10.50, 10.50, 10.50, 11.00
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.RANGED_BARRACKS_RECRUITMENT_TIME_BONUS,
      EffectAmount.asPerLevel([
        2.25, 2.25, 2.75, 2.75, 3.25, 3.25, 3.25, 4.00, 4.00, 4.00,
        4.75, 4.75, 5.25, 5.25, 5.75, 5.75, 5.75, 6.50, 6.50, 6.50,
        7.25, 7.25, 7.75, 7.75, 8.25, 8.25, 8.25, 9.00, 9.00, 9.00,
        9.75, 9.75, 10.25, 10.25, 10.75, 10.75, 10.75, 11.50, 11.50, 11.50,
        12.25, 12.25, 12.75, 12.75, 13.25, 13.25, 13.25, 14.00, 14.00, 14.00,
        14.75, 14.75, 15.25, 15.25, 15.75, 15.75, 15.75, 16.50, 16.75, 27.00
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140
        ],
        bronzeAge: [
          22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140
        ],
        minoanEra: [
          42,45,47,50,52,55,57,60,62,65,67,70,72,75,77,80,82,85,87,90,92,95,97,100,102,105,107,110,112,115,117,120,122,125,127,130,132,135,137,140,142,145,147,150,152,155,157,160,162,165,167,170,172,175,177,180,182,185,187,190
        ],
        classicGreece: [
          63,66,69,72,75,78,81,84,87,90,93,96,99,102,105,108,111,114,117,120,123,126,129,132,135,138,141,144,147,150,153,156,159,162,165,168,171,174,177,180,183,186,189,192,195,198,201,204,207,210,213,216,219,222,225,228,231,234,237,240
        ],
        earlyRome: [
          83,87,90,94,97,101,104,108,111,115,118,122,125,129,132,136,139,143,146,150,153,157,160,164,167,171,174,178,181,185,188,192,195,199,202,206,209,213,216,220,223,227,230,234,237,241,244,248,251,255,258,262,265,269,272,276,279,283,286,290
        ],
        romanEmpire: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        byzantineEra: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        ageOfTheFranks: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        feudalAge: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        iberianEra: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        kingdomOfSicily: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        highMiddleAges: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        earlyGothicEra: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ],
        lateGothicEra: [
          104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300,304,308,312,316,320,324,328,332,336,340
        ]
      }).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
  ]),
};

export default DraculasCastle;
